import request from '@/utils/request'

const profix = '/front/api'


// 上传内容
export function saveContent(data) {
    return request({
        url: `${profix}/lvai/saveContent`,
        method: 'post',
        data: data
    })
}


// 删除内容
export function deleteContent(data) {
    return request({
        url: `${profix}/lvai/deleteContent`,
        method: 'post',
        params: data
    })
}


// 获取内容
export function getAll(data) {
    return request({
        url: `${profix}/lvai/getAll`,
        method: 'get',
        params: data
    })
}
// 上传标签
export function saveTagContent(data) {
    return request({
        url: `${profix}/lvai/saveTagContent`,
        method: 'post',
        data: data
    })
}

// 获取内容
export function getTagAll(data) {
    return request({
        url: `${profix}/lvai/getTagAll`,
        method: 'get',
        params: data
    })
}






// 大模型上传-单篇文献
export function uploadkb(data) {
    return request({
        url: `/AIserve/Chatdoc/uploadkb`,
        method: 'post',
        data: data
    })
}

// 上传多篇
export function uploadGroup(data) {
    return request({
        url: `/AIserve/Chatdocs/uploadGroup`,
        method: 'post',
        data: data
    })
}


// 3-基于单篇文献的问答
export function chat(data) {
    return request({
        url: `/AIserve/Chatdoc/chat`,
        method: 'post',
        data: data
    })
}
// 多篇问答
export function chatByMulti(data) {
    return request({
        url: `/AIserve/Chatdocs/chat`,
        method: 'post',
        data: data
    })
}


// 撰写
export function autoWrite(data) {
    let url = "/AIserve/Chat/autoWrite";
    const headers = new Headers({
        "Content-Type": "application/json",
    });
    return fetch(url, {
        method: "post",
        headers: headers,
        body: JSON.stringify(data),
    })
}

// 溯源
export function expansion(data) {
    return request({
        url: `/AIserve/Chat/expansion`,
        method: 'post',
        data: data,
    })
}


// 通用问答
export function chatNoDoc(data) {
    return request({
        url: `/AIserve/Chat/chat`,
        method: 'post',
        data: data,
    })
}

export function law_qa(data) {
    return request({
        url: `/new-model/law_qa`,
        method: 'post',
        data: data,
    })
}


// 溯源接口
export function geTraceData(data) {
    return request({
        url: '/law_context',
        method: 'post',
        data
    })
}

// 获取历史记录
export function getUserQAList(typec) {
    return request({
        url: `/lvai/getUserQAList/${typec}`,
        method: 'get',
    })
}

// 签出历史记录
export function getUserQA(sessoinid) {
    return request({
        url: `/lvai/getUserQA/${sessoinid}`,
        method: 'get',
    })
}

// 清除历史记录
export function clearHistoryQa() {
    return request({
        // url: 'http://10.31.75.53:8130/UserDataCenter/IsCollectFile',
        url: '/lvai/clearHistoryQa',
        method: 'get'
    })
}


// 获取用户单篇对话
export function getUserSingleQA(sessoinid) {
    return request({
        url: `/lvai/getUserSingleQA/${sessoinid}`,
        method: 'get',
    })
}

// 删除用户单篇对话
export function clearSingleHistoryQa(sessoinid) {
    console.log('sessoinid------------------------', sessoinid)
    return request({
        url: `/lvai/clearSingleHistoryQa`,
        method: 'get',
    })
}

// 获取单篇对话列表
export function getUserSingleQAList() {
    return request({
        url: `/lvai/getUserSingleQAList`,
        method: 'get',
    })
}


// 清除智慧办案列表
export function clearJudgeHistoryQa(sessoinid) {
    return request({
        url: `/lvai/clearJudgeHistoryQa`,
        method: 'get',
    })
}
// 获取智慧办案对话列表
export function getUserJudgeQAList() {
    return request({
        url: `/lvai/getUserJudgeQAList`,
        method: 'get',
    })
}
// 签出智慧办案历史记录
export function getUseJudgeQA(sessoinid) {
    return request({
        url: `/lvai/getUseJudgeQA/${sessoinid}`,
        method: 'get',
    })
}
// 创建智慧办案新会话
export function postNewSession(data) {
    return request({
        url: `/lvai/judge_param`,
        method: 'post',
        data
    })
}

// 删除单条对话
export function clearQA(sessoinid, type) {
    return request({
        url: `/lvai/clearQA/${type}/${sessoinid}`,
        method: 'get',
    })
}

// 会话置顶
export function maketopQA(sessoinid, type) {
    return request({
        url: `/lvai/maketopQA/${type}/${sessoinid}`,
        method: 'get',
    })
}

//调整会话名称
export function modifyTitle(title, type, recid) {
    return request({
        url: '/lvai/modifyTitle',
        method: 'post',
        data: {
            title,
            type,
            recid
        }
    })
}

// 调整智慧办案会话param
export function modifySessionParam(data) {
    return request({
        url: '/lvai/judge_param_m',
        method: 'post',
        data
    })
}

// 模糊查询作者
export function findAuthors(pas) {
    return request({
      url: `/lvai/findAuthors/${pas}`,
      method: 'get',
    })
}

export function sendEmail(data) {
    const headers = new Headers({
        'Content-Type': 'multipart/form-data',
    });
    return request({
        headers: {"Content-Type": "multipart/form-data"},
        url: '/lvai/sendEmail',
        method: 'post',
        data
    })
}